import { slideToggle } from 'utils/slideToggleAccordion';
import { useToggle } from 'hooks/useToggle';
import { useRef, useEffect, ReactNode } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';

/**
 * AccordionListItem
 * @param heading 見出し要素
 * @param children 子要素
 * @param selected 選択中か
 * @param isOpen アコーディオンが開いているか
 */
interface Props {
  heading: ReactNode;
  children: ReactNode;
  selected?: boolean;
  isOpen?: boolean;
}

export const AccordionListItem = ({
  heading,
  children,
  selected,
  isOpen,
}: Props) => {
  const [open, toggle] = useToggle(false);
  const listContentRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      toggle();
      slideToggle(listContentRef, true);
    }
  }, [isOpen, toggle]);

  return (
    <li className={styles.accordion__item}>
      <button
        className={classnames(styles.accordion__button)}
        type="button"
        onClick={() => {
          toggle();
          slideToggle(listContentRef, !open);
        }}
      >
        <div className={styles.accordion__contentWrapper}>
          <span className={styles.accordion__content}>{heading}</span>
          <span
            className={classnames(styles.accordion__icon, {
              [styles['accordion__icon--selected']]: selected === true,
            })}
          >
            選択中
          </span>
        </div>
        <span className={styles.accordion__arrow}>
          <span
            className={classnames(styles.accordion__arrowIcon, {
              [styles.accordion__arrowIconDown]: !open,
              [styles.accordion__arrowIconUp]: open,
            })}
          />
        </span>
      </button>
      <ul ref={listContentRef} style={{ display: 'none' }}>
        {children}
      </ul>
    </li>
  );
};
